import { render, staticRenderFns } from "./Foto.vue?vue&type=template&id=dd716ddc&scoped=true&"
import script from "./Foto.vue?vue&type=script&lang=js&"
export * from "./Foto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd716ddc",
  null
  
)

export default component.exports